import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import SubPageTitle from 'components/_common/panel/SubPageTitle';
import { TimelineList } from '../_common/timeline/TimelineList';

export const TimelinePage = () => {
	const { t } = useTranslation();
	return (
		<>
			<Helmet title={t('timeline.title')} />
			<SubPageTitle title={t('timeline.title')} />
			<TimelineList />
		</>
	);
};
